import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { CategoryDto } from '@/modules/counterparty/dto/category.dto.ts';
import type { Category } from '@/modules/counterparty/types/priority.type.ts';

export class CategoryAdapter {
  private static map(response: CategoryDto): Category {
    return {
      name: response.Приоритет,
    };
  }

  static mapList(response: ItemsDto<CategoryDto>) {
    return response.items.map(CategoryAdapter.map);
  }
}
